module.exports = __webpack_public_path__ + "static/media/messenger.6f17d592.svg";